import { useEffect, useState } from "react";
import {
  Box, Typography, Paper, Table, TableBody, TableCell,
  TableHead, TableRow,
  Button, IconButton, Tooltip
} from "@mui/material";
import ScrollableTableContainer from "components/table/ScrollableTableContainer";
import TableActionButton from "components/table/TableActionButton";
import TableActions from "components/table/TableActions";
import TableStatusChip from "components/table/TableStatusChip";
import PageHeader from "components/PageHeader";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import api from "utils/api";
import { useToast } from "contexts/ToastContext";

export default function ProductSubCategoryList() {
  const [subCategories, setSubCategories] = useState([]);
  const navigate = useNavigate();
  const { showToast, showApiError } = useToast();

  useEffect(() => {
    fetchSubCategories();
  }, []);

  const fetchSubCategories = async () => {
    try {
      const res = await api.get("/product/sub/category/list");
      setSubCategories(res.data.data || []);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this sub-category?")) return;
    try {
      await api.delete(`/product/sub/category/delete/${id}`);
      fetchSubCategories();
    } catch (error) {
      showApiError(error, "Delete failed");
      console.error("Delete Error:", error);
    }
  };

  const getCategoryName = (sub) => sub.category?.name_en || "-";

  const getImageUrl = (sub) => sub.imageDoc?.imageUrl || null;

  return (
    <Box>
      <PageHeader
        variant="nested"
        onBack={() => navigate(-1)}
        title="Product Sub Categories"
        subtitle="Manage sub-categories linked to product categories."
        count={subCategories.length}
        actionLabel="Add Sub Category"
        actionIcon={AddIcon}
        onAction={() => navigate("/product/sub-category/create")}
      />

      <Paper elevation={0} sx={{ border: "1px solid", borderColor: "divider", borderRadius: 3 }}>
        <ScrollableTableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: "grey.50" }}>
                <TableCell sx={{ fontWeight: 700 }}>#</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Image</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Name (EN)</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Name (AR)</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Category</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 700 }} align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {subCategories.map((sub, index) => (
                <TableRow key={sub.id} hover>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    {getImageUrl(sub) ? (
                      <img src={getImageUrl(sub)} alt="" width={40} height={40} style={{ borderRadius: 8, objectFit: "cover" }} />
                    ) : (
                      "—"
                    )}
                  </TableCell>
                  <TableCell>{sub.name_en}</TableCell>
                  <TableCell>{sub.name_ar}</TableCell>
                  <TableCell>{getCategoryName(sub)}</TableCell>
                  <TableCell>
                    <TableStatusChip active={!!sub.status} />
                  </TableCell>
                  <TableCell align="center">
                    <TableActions>
                      <TableActionButton action="edit" onClick={() => navigate(`/product/sub-category/edit/${sub.id}`)} />
                      <TableActionButton action="delete" onClick={() => handleDelete(sub.id)} />
                    </TableActions>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ScrollableTableContainer>
      </Paper>
    </Box>
  );
}
